export const NAME = 'company-general';
export const DEBOUNCE_TIME = 1000;
export const DEFAULT_TAX_ELEMENTS = [0, 1, 2, 3, 4, 5, 6];
